import React from 'react';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';

const PretextHaltungsaenderung = () => {
  return(
    <Paper style={{padding:"15px"}}>
      <p>
        Hier können Sie folgende Änderungen anzeigen:
      </p>

      <h3 style={{marginBottom:"0"}}>1. Änderungen die Ihre Person betreffen</h3>
      Zum Beispiel Umzug, Namensänderung oder Änderungen an Ihren 
      Kontaktdaten (Telefonnummer, E-Mail). Falls Sie umziehen, können Sie bestimmen, ob alle oder nur ein 
      Teil Ihrer gemeldeten Tiere mit an die neue Anschrift umziehen.

      <h3 style={{marginBottom:"0"}}>2. Änderungen die den Aufenthalt Ihres gemeldeten Tierbestands betreffen</h3>

      Sie können alle oder auch einzelne 
      Tiere entweder an Ihrem Wohnort oder an einem abweichenden Haltungsort ummelden.          

      <p>
        Bitte beachten Sie, dass Sie immer nur den Umzug von Tieren an <b>einen Ort</b> melden können. Falls Tiere auf 
        mehrere Haltungsorte verteilt werden, müssen Sie dieses Formular für jeden Haltungsort getrennt ausfüllen und absenden.
        Falls sich nicht nur der Haltungsort ändert, sondern auch der Besitzer/Halter/Eigentümer, verwenden Sie bitte das 
        Formular <Link href="/?form=FormularWeitergabe">02 Weitergabe</Link>.
      </p>
      
    </Paper>
  )
}

export default PretextHaltungsaenderung;
